import { useEffect, useState } from "react";

interface Toast {
  id: number;
  message: string;
}

let nextId = 1;
const listeners = new Set<(t: Toast) => void>();

export function toast(message: string): void {
  const t = { id: nextId++, message };
  listeners.forEach((l) => l(t));
}

export function Toaster() {
  const [toasts, setToasts] = useState<Toast[]>([]);

  useEffect(() => {
    const onToast = (t: Toast) => {
      setToasts((cur) => [...cur, t]);
      setTimeout(() => {
        setToasts((cur) => cur.filter((x) => x.id !== t.id));
      }, 4000);
    };
    listeners.add(onToast);
    return () => {
      listeners.delete(onToast);
    };
  }, []);

  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className="pointer-events-none fixed inset-x-0 z-40 flex flex-col items-center gap-2 px-4 bottom-[calc(4.25rem+env(safe-area-inset-bottom))] sm:bottom-4"
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          className="ff-toast pointer-events-auto rounded-[14px] bg-abyss px-5 py-2.5 text-sm font-semibold text-paper-ink shadow-abyss"
        >
          {t.message}
        </div>
      ))}
      {/* 180 ms opacity + 6 px translate; ends up as a soft rise. Global
          prefers-reduced-motion rule in index.css zeroes the duration for
          users who ask for reduced motion — no per-component check needed. */}
      <style>{`
        .ff-toast {
          animation: ff-toast-in 180ms ease-out both;
        }
        @keyframes ff-toast-in {
          from { opacity: 0; transform: translateY(6px); }
          to { opacity: 1; transform: none; }
        }
      `}</style>
    </div>
  );
}
